import React from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  List,
  ListItem,
  Popper,
  Radio,
  RadioGroup,
  Typography,
  Popover,
  Paper,
  Grid,
} from "@mui/material";
// import styles from "styles/component/Popper.module.scss";
import styles from "styles/component/CustomPopover.module.scss";

import asset from "json/assets";
import { landingAreasColor, landingAreasType } from "json/constants";

export const LandingAreaMarker = (props) => {
  const {
    markerType,
    handleChangeMarkerType,
    selectedMarkerMod2,
    handelChangeMarkerColor,
    errorMsg,
    handleSave,
    errorComponent
  } = props;
 
  return (
    <Box className={styles.popover_body_new}>
      {/* <MultiSelect /> */}
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label">SELECT TYPE</FormLabel>
        <RadioGroup
          className={styles.marker_option}
          aria-labelledby="demo-radio-buttons-group-label"
          // defaultValue="FLAG"
          name="radio-buttons-group"
          value={markerType}
          onChange={handleChangeMarkerType}
        >
          {landingAreasType?.map((marker, index) => (
            <FormControlLabel
              value={marker.value}
              control={<Radio  checked={marker.value===markerType}/>}
              label={marker.label}
              key={index}
            />
          ))}
        </RadioGroup>

        <FormLabel id="demo-radio-buttons-group-label2">SELECT COLOR</FormLabel>
        <RadioGroup
          className={styles.marker_option}
          aria-labelledby="demo-radio-buttons-group-label"
          // defaultValue="RED"
          name="radio-buttons-group"
          value={selectedMarkerMod2}
          onChange={handelChangeMarkerColor}
        >
          {landingAreasColor?.map((marker, index) => (
            <FormControlLabel
              value={marker.value}
              control={<Radio  checked={marker.value===selectedMarkerMod2} />}
              label={marker.label}
              key={index}
            />
          ))}
        </RadioGroup>
      </FormControl>
      {errorMsg && errorComponent()}
      <Box className={styles.popover_ftr}>
        <Button
        //   to={"#"}
          className={styles.blue_btn}
          onClick={() => handleSave()}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};
